exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lists-customers-create-email .modal-content{max-height:600px}#modal-lists-customers-create-email .file-select{font-size:9pt}#modal-lists-customers-create-email .file-select .files-selected{padding-top:10px}#modal-lists-customers-create-email .file-select .files-selected .fa-window-close{font-size:12pt;color:red}", ""]);

// exports
